import * as React from 'react'

export const SVG_PlayIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="57" viewBox="0 0 52 57">
        <path
            fill="#FFF"
            d="M50.527 26.015L4.304.365C3.41-.131 2.317-.12 1.433.388.543.9 0 1.836 0 2.85v51.3c0 1.015.543 1.95 1.433 2.462.45.257.953.388 1.456.388.485 0 .976-.12 1.415-.365l46.223-25.65C51.434 30.478 52 29.532 52 28.5c0-1.032-.566-1.978-1.473-2.485z"
        />
    </svg>
)
